import { AxiosInstance } from 'axios';
import { initUserLogService, UserLogService } from './UserlogService';

export interface ApplogServiceModel {
  userLog: UserLogService;
}

export const initApplogService = (axios: AxiosInstance): ApplogServiceModel => ({
  userLog: initUserLogService(axios),
});
